import React, { Component } from "react";
// import { reduxForm, Field } from "redux-form";
import { Form, Field } from "react-final-form";
import FormInput from "../../Components/FormInput/FormInput";
import Button from "Components/Button";
import LoadingIcon from "../../Components/LoadingIcon";

import styles from "./styles";
import { withStyles } from "@material-ui/styles";

const validate = values => {
  const errors = {};
  if (!values.resetEmail) {
    errors.resetEmail = "Required";
  }
  return errors;
};

class ForgottenPasswordForm extends Component {
  render() {
    const { handleSubmit, fetching, classes, error } = this.props;
    return (
      <Form onSubmit={handleSubmit} validate={validate}>
        {({ handleSubmit }) => (
          <form onSubmit={handleSubmit}>
            <div
              className={classes.container}
            >
              <Field
                name={"resetEmail"}
                render={_props => {
                  return (
                    <FormInput
                      placeholder={"Insert Your Email"}
                      type={"email"}
                      {..._props}
                    />
                  );
                }}
              />
              {error && <p className={classes.error}>{error}</p>}
            </div>
            <div className={classes.button}>
              <Button onClick={handleSubmit}>
                {fetching ? <LoadingIcon color={"white"} /> : "Send reset link"}
              </Button>
            </div>
          </form>
        )}
      </Form>
    );
  }
}

export default withStyles(styles)(ForgottenPasswordForm);
